import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { CheckCircle, FileText } from "lucide-react";

export function SubsidySection() {
  const conditions = [
    {
      title: "雇用形態",
      content: "雇用保険に加入している正社員（出向・派遣は対象外）"
    },
    {
      title: "受講人数",
      content: "5名以上を推奨"
    },
    {
      title: "研修時間",
      content: "10時間以上（複数回に分割可）"
    },
    {
      title: "実施形式",
      content: "勤務時間内におけるOFF-JTであること"
    }
  ];

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            リスキリング助成金とは？
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            「人材開発支援助成金（リスキリング支援コース）」は、社員の成長分野スキル取得にかかる研修費用を助成する制度です。
            <br className="hidden md:block" />
            AI、IT、デジタルツールの研修も対象となっており、中小企業には最大75%の助成が適用されます。
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <Card className="border-gray-200 shadow-sm">
            <CardHeader>
              <CardTitle className="flex items-center text-xl text-gray-900">
                <CheckCircle className="w-6 h-6 mr-3 text-green-600" />
                助成金の特徴
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">成長分野のスキル取得を支援</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">AI・IT・デジタルツール研修が対象</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">中小企業は最大75%助成</span>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">厚生労働省の公式制度</span>
                </li>
              </ul>
            </CardContent>
          </Card>
          
          <Card className="border-gray-200 shadow-sm">
            <CardHeader>
              <CardTitle className="flex items-center text-xl text-gray-900">
                <FileText className="w-6 h-6 mr-3 text-blue-600" />
                助成金額の例
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg">
                  <span className="text-gray-700">研修費用（1名あたり）</span>
                  <span className="text-xl text-gray-900">¥400,000</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg">
                  <span className="text-gray-700">助成額（75%）</span>
                  <span className="text-xl text-green-600">¥300,000</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-black text-white rounded-lg">
                  <span>実質負担額</span>
                  <span className="text-xl">¥100,000</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        
        <div className="mb-16">
          <h3 className="text-xl sm:text-2xl mb-6 sm:mb-8 text-center text-gray-900">助成金の活用条件</h3>
          
          {/* モバイル用カードレイアウト */}
          <div className="block sm:hidden space-y-4">
            {conditions.map((condition, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                <div className="text-sm font-semibold text-gray-900 mb-2">{condition.title}</div>
                <div className="text-sm text-gray-700">{condition.content}</div>
              </div>
            ))}
          </div>
          
          {/* デスクトップ用テーブル */}
          <div className="hidden sm:block overflow-x-auto">
            <table className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-sm font-semibold text-gray-900 border-b border-gray-200">条件項目</th>
                  <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-sm font-semibold text-gray-900 border-b border-gray-200">内容</th>
                </tr>
              </thead>
              <tbody>
                {conditions.map((condition, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-sm text-gray-900 border-b border-gray-200">
                      {condition.title}
                    </td>
                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-sm text-gray-700 border-b border-gray-200">
                      {condition.content}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
